module.exports = __webpack_public_path__ + "static/img/s37.27c80765.png";